import { generateGuid } from "@entrilia/shared/utilities/generateGuid.ts";
import type { CashFlowValue, ReportField } from "../../../../../../../../../api/types/svTypes.ts";
import type { DrillDownPage } from "../../../../../store/types/drillDownPageState.types.ts";

export const createCashFlowDrillDownPage = (
  reportId: string | undefined,
  measure: ReportField | undefined,
  value: Pick<CashFlowValue, "amount" | "amountFormatted" | "description" | "drillDownInfo">
): DrillDownPage | undefined => {
  if (!reportId || !value.drillDownInfo) {
    return undefined;
  }

  return {
    pageId: generateGuid(),
    reportId,
    onlyLedger: false,
    chartOfAccounts: false,
    layer: {
      measure: measure
        ? { ...measure, config: { ...measure.config, customLabel: value.description || measure.config.customLabel } }
        : undefined,
      cell: { value: value.amount, formattedValue: value.amountFormatted, drillDownId: undefined },
      info: value.drillDownInfo,
    },
  };
};
